import React, { Fragment } from 'react';
import {
  PageLayout,
  BupSpinner,
  ErrorMessage,
  ContentHTML,
} from '@BUP/components';
import './styles.css';
import { useParams } from 'react-router-dom';
import { useTopic, useResource } from '@BUP/hooks';
import DefaultTopicImage from '@BUP/assets/Images/Topics/default_topic.jpeg';
import { useTranslation } from 'react-i18next';

const TopicDetailPage = () => {
  const { resourceId, topicId } = useParams();
  const {
    data: resource,
    isLoading: isLoadingResource,
    error: errorResource,
  } = useResource(resourceId);
  const { data: topic, isLoading: isLoadingTopic, errorTopic } = useTopic(
    topicId
  );

  const [t] = useTranslation();

  if (isLoadingResource) return <BupSpinner size="large" />;

  if (errorTopic || errorResource) return <ErrorMessage />;

  return (
    <PageLayout
      pageName={`${t('pages.resources.pageNameText1')}${' '}${
        resource?.name || t('pages.resources.pageNameText2')
      }`}
      backButton
    >
      <div className="topic-detail-page-container">
        {isLoadingTopic && !isLoadingResource ? (
          <BupSpinner size="large" />
        ) : (
          <>
            <div className="title-wrapper">
              <h1>{topic?.name || t('pages.resources.pageNameText2')}</h1>
            </div>
            <div className="description-wrapper">
              <div className="description-text">
                <p>{topic?.description || ''}</p>
              </div>
              <div className="description-image">
                <img src={topic?.imgUrl || DefaultTopicImage} alt="" />
              </div>
            </div>
            <ContentHTML element={topic} />
          </>
        )}
      </div>
    </PageLayout>
  );
};

export default TopicDetailPage;
